import { render, staticRenderFns } from "./productInspector.vue?vue&type=template&id=0cac9288&lang=pug"
import script from "./productInspector.vue?vue&type=script&lang=js"
export * from "./productInspector.vue?vue&type=script&lang=js"
import style0 from "./productInspector.vue?vue&type=style&index=0&id=0cac9288&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports